import { Stack, Typography, Box, useTheme, useMediaQuery } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

function ListOperations({ fetchOperations, operations, setSelectedRows }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [modifiedColumns, setModifiedColumns] = useState([])

  let navigate = useNavigate()
  const [rows, setRows] = useState(20)
  const [page, setPage] = useState(0)
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchOperations(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchOperations(url)
  }
  // LAP-733 (GE022)
  const columns = useMemo(
    () => [
      // { field: 'id', headerName: 'ID', width: 90 },
      {
        field: 'EquipementType',
        headerName: t('maintenance.headerEquipmentType'),
        width: 140,
        editable: true,
      },
      {
        field: 'EquipementSubType',
        headerName: t('maintenance.headerEquipmentSubType'),
        width: 200,
        editable: true,
      },
      {
        field: 'EquipementName',
        headerName: t('maintenance.headerEquipmentName'),
        width: 200,
        editable: true,
      },
      {
        field: 'NextMaintenanceDate',
        headerName: t('maintenance.headerNextMaintenance'),
        width: 200,
        editable: true,
      },
      {
        field: 'MaintenanceBudget',
        headerName: t('maintenance.headerBudget'),
        width: 100,
        editable: true,
        valueGetter: (params) =>
          `${params.row.MaintenanceBudget ? params.row.MaintenanceBudget : ''} €`,
      },
      {
        field: 'NextMaintenanceCost',
        headerName: t('maintenance.headerMaintenanceCost'),
        width: 180,
        editable: true,
        valueGetter: (params) =>
          `${params.row.NextMaintenanceCost ? params.row.NextMaintenanceCost : ''} €`,
      },
      {
        field: 'Statut',
        headerName: t('maintenance.headerStatus'),
        width: 100,
        editable: true,
        renderCell: (params) => {
          let color = 'red'
          if (params.row.Statut === 'actif') {
            color = 'green'
          }
          // Note: params.row.Statut is a backend status code ('actif'/'désactivé')
          // and is intentionally not translated here. LAP-733 (GE022)
          return <Box sx={{ color: color }}>{params.row.Statut}</Box>
        },
      },
    ],
    [t],
  )

  useEffect(() => {
    if (isMobile) {
      setModifiedColumns([
        {
          headerName: t('maintenance.headerEquipmentName'),
          width: 280,
          renderCell: (params) => (
            <Box py={2} mt={1}>
              <Box fontWeight={600}>{params.row.EquipementName}</Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('maintenance.headerEquipmentType')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.EquipementType}
                </Box>
              </Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('maintenance.headerEquipmentSubType')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.EquipementSubType}
                </Box>
              </Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('maintenance.headerMaintenanceCost')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.NextMaintenanceCost ? params.row.NextMaintenanceCost : ''} €
                </Box>
              </Box>
              <Box>
                {/* LAP-733 (GE022) */}
                <Box component={'span'}>{t('maintenance.headerBudget')}:</Box>{' '}
                <Box component={'span'} fontWeight={600}>
                  {params.row.MaintenanceBudget ? params.row.MaintenanceBudget : ''} €
                </Box>
              </Box>
            </Box>
          ),
        },
      ])
    } else {
      setModifiedColumns(columns)
    }
  }, [isMobile, columns, t])
  return (
    <div
      style={{
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        {/* LAP-733 (GE022) */}
        {t('maintenance.pageTitle')} ({operations.count})
      </Typography>

      <DataGrid
        sx={{ height: 750 }}
        rows={operations.results ? operations.results : []}
        columns={modifiedColumns}
        getRowHeight={() => (isMobile ? 'auto' : 50)}
        pageSize={rows}
        rowCount={operations.count ? operations.count : 0}
        onPageSizeChange={handleRowsChange}
        onPageChange={handlePageChange}
        rowsPerPageOptions={[10, 20, 40, 80, 100]}
        pagination
        onSelectionModelChange={(itm) => setSelectedRows([...itm])}
        paginationMode="server"
        // disableSelectionOnClick
        checkboxSelection
        disableSelectionOnClick
        onRowClick={(e) => navigate(`/domicile/entretien/${e.row.id}`)}

        // onRowClick={(params, event) => {
        //   if (event.target.localName === 'div') {
        //     // window.open(params.row.Lien)
        //     navigate(`/domicile/vehicule/{}`)
        //   }
        // }}
      />
    </div>
  )
}
export default ListOperations
